// tslint:disable-next-line:no-reference
/// <reference path="../typings/index.d.ts" />
// tslint:disable-next-line:no-reference
/// <reference path="index.d.ts" />
import Analytics from '@withlocals/withlocals-analytics';
import { WlWindow } from 'typings/globals/cordova';
import { urls$ } from 'utils/UrlListener';
import { path2GACategory } from 'utils/analytics';
import { useI18n } from '~/stores/i18n';

import availableLanguages from '../resources/languages.json';
import { history } from './wlHistory';

declare const window: WlWindow;

export default () => {
  if (window.analBuffer) {
    window.analBuffer.push = (...events) => {
      events.forEach((event) => Analytics.pushBitterbal(event));
    };
    window.analBuffer.forEach((event) => Analytics.pushBitterbal(event));
  }

  console.log('Main started');

  const trackPage = (pathName) => {
    const path = pathName.split('/').filter((x) => !!x);
    if (availableLanguages.indexOf(path[0]) > -1) {
      path.splice(0, 1);
    }
    const pageCategory = path2GACategory(pathName);
    const authCategories = ['Log in', 'Sign up'];
    if (
      authCategories.includes(pageCategory) &&
      !authCategories.includes(window.currentPageCategory)
    ) {
      window.previousNonAuthPageCategory = window.currentPageCategory;
    }
    window.currentPageCategory = pageCategory;

    Analytics.page(path.join('/'), {
      pathName,
      pageCategory,
      title: window.document.title,
      lang: useI18n.getState().lang,
    });
  };

  // handle old (hash-based) urls
  urls$.subscribe((pathName) => {
    const { location } = window;
    trackPage(pathName);
    if (pathName === '/' && location.hash.length > 0) {
      history.replace(location.hash.substr(1));
    }
  });

  return 'loaded';
};
